import type * as service from "../../service";
import { LANGUAGE } from "_constants";
import { MESSAGES } from "./constants";

export type VolleyballTabKey = "narration" | "stats" | "match";

export const VOLLEYBALL_TABS: { key: VolleyballTabKey; label: string }[] = [
  { key: "narration", label: "Narration" },
  { key: "stats", label: "Statistics" },
  { key: "match", label: "Match" },
];

export const getVolleyballTabIndex = (key: VolleyballTabKey): number =>
  VOLLEYBALL_TABS.findIndex((t) => t.key === key);

export const getVolleyballTabKeyByIndex = (i: number): VolleyballTabKey =>
  VOLLEYBALL_TABS[i]?.key ?? "narration";

export const isPreMatch = (status: service.MatchStatus): boolean => {
  const stsVal = status?.sts as unknown;
  const stsNum =
    typeof stsVal === "number"
      ? stsVal
      : typeof stsVal === "string"
      ? Number(stsVal)
      : NaN;
  const notStartedByStatus = !Number.isNaN(stsNum) && stsNum === 0;

  const tmVal = status?.tm as unknown;
  const tmNum =
    typeof tmVal === "number"
      ? tmVal
      : typeof tmVal === "string"
      ? Number(tmVal)
      : NaN;
  const notStartedByTime = !Number.isNaN(tmNum) && tmNum <= 0;

  const noLiveNsc = !status?.nsc;
  return (notStartedByStatus || notStartedByTime) && noLiveNsc;
};

export const messageGeneratorFactory =
  () =>
  ({
    language,
    normalizedStatusCode,
  }: {
    language: LANGUAGE;
    normalizedStatusCode?: string;
  }) => {
    if (!normalizedStatusCode) return undefined;
    const langDict = MESSAGES[language];
    if (!langDict) return undefined;
    return { message: langDict[normalizedStatusCode] };
  };
